import { useEffect } from 'react';
export function useBackHandler({ enabled, callback }) {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                callback();
            }
        };
        document?.body?.addEventListener?.('keyup', handleEscape);
        return () => {
            document?.body?.removeEventListener?.('keyup', handleEscape);
        };
    }, [enabled, callback]);
}
